/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerMedicalFormProcessDto } from './BorrowerMedicalFormProcessDto';
import {
    BorrowerMedicalFormProcessDtoFromJSON,
    BorrowerMedicalFormProcessDtoFromJSONTyped,
    BorrowerMedicalFormProcessDtoToJSON,
    BorrowerMedicalFormProcessDtoToJSONTyped,
} from './BorrowerMedicalFormProcessDto';
import type { BorrowerProcessStepDto } from './BorrowerProcessStepDto';
import {
    BorrowerProcessStepDtoFromJSON,
    BorrowerProcessStepDtoFromJSONTyped,
    BorrowerProcessStepDtoToJSON,
    BorrowerProcessStepDtoToJSONTyped,
} from './BorrowerProcessStepDto';
import type { BorrowerMedicalProcessDto } from './BorrowerMedicalProcessDto';
import {
    BorrowerMedicalProcessDtoFromJSON,
    BorrowerMedicalProcessDtoFromJSONTyped,
    BorrowerMedicalProcessDtoToJSON,
    BorrowerMedicalProcessDtoToJSONTyped,
} from './BorrowerMedicalProcessDto';
import type { MedicalSurveyResponseProcessDto } from './MedicalSurveyResponseProcessDto';
import {
    MedicalSurveyResponseProcessDtoFromJSON,
    MedicalSurveyResponseProcessDtoFromJSONTyped,
    MedicalSurveyResponseProcessDtoToJSON,
    MedicalSurveyResponseProcessDtoToJSONTyped,
} from './MedicalSurveyResponseProcessDto';

/**
 * 
 * @export
 * @interface BorrowerProcessDto
 */
export interface BorrowerProcessDto {
    /**
     * 
     * @type {BorrowerMedicalProcessDto}
     * @memberof BorrowerProcessDto
     */
    medicalSurvey?: BorrowerMedicalProcessDto;
    /**
     * 
     * @type {MedicalSurveyResponseProcessDto}
     * @memberof BorrowerProcessDto
     */
    medicalSurveyResponse?: MedicalSurveyResponseProcessDto;
    /**
     * 
     * @type {BorrowerProcessStepDto}
     * @memberof BorrowerProcessDto
     */
    approvedAgreement: BorrowerProcessStepDto;
    /**
     * 
     * @type {BorrowerProcessStepDto}
     * @memberof BorrowerProcessDto
     */
    subscriptionRequest: BorrowerProcessStepDto;
    /**
     * 
     * @type {BorrowerProcessStepDto}
     * @memberof BorrowerProcessDto
     */
    subscriptionCertificate: BorrowerProcessStepDto;
    /**
     * 
     * @type {BorrowerMedicalFormProcessDto}
     * @memberof BorrowerProcessDto
     */
    medicalForm?: BorrowerMedicalFormProcessDto;
    /**
     * Statut du dossier chez le partenaire (ex "En cours de gestion par MUTLOG")
     * @type {string}
     * @memberof BorrowerProcessDto
     */
    partnerCaseStatus?: string | null;
    /**
     * Détail du statut chez le partenaire (ex "En attente d'une décision médicale de MUTLOG")
     * @type {string}
     * @memberof BorrowerProcessDto
     */
    partnerCaseStatusDetail?: string | null;
}

/**
 * Check if a given object implements the BorrowerProcessDto interface.
 */
export function instanceOfBorrowerProcessDto(value: object): value is BorrowerProcessDto {
    if (!('approvedAgreement' in value) || value['approvedAgreement'] === undefined) return false;
    if (!('subscriptionRequest' in value) || value['subscriptionRequest'] === undefined) return false;
    if (!('subscriptionCertificate' in value) || value['subscriptionCertificate'] === undefined) return false;
    return true;
}

export function BorrowerProcessDtoFromJSON(json: any): BorrowerProcessDto {
    return BorrowerProcessDtoFromJSONTyped(json, false);
}

export function BorrowerProcessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerProcessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'medicalSurvey': json['medicalSurvey'] == null ? undefined : BorrowerMedicalProcessDtoFromJSON(json['medicalSurvey']),
        'medicalSurveyResponse': json['medicalSurveyResponse'] == null ? undefined : MedicalSurveyResponseProcessDtoFromJSON(json['medicalSurveyResponse']),
        'approvedAgreement': BorrowerProcessStepDtoFromJSON(json['approvedAgreement']),
        'subscriptionRequest': BorrowerProcessStepDtoFromJSON(json['subscriptionRequest']),
        'subscriptionCertificate': BorrowerProcessStepDtoFromJSON(json['subscriptionCertificate']),
        'medicalForm': json['medicalForm'] == null ? undefined : BorrowerMedicalFormProcessDtoFromJSON(json['medicalForm']),
        'partnerCaseStatus': json['partnerCaseStatus'] == null ? undefined : json['partnerCaseStatus'],
        'partnerCaseStatusDetail': json['partnerCaseStatusDetail'] == null ? undefined : json['partnerCaseStatusDetail'],
    };
}

export function BorrowerProcessDtoToJSON(json: any): BorrowerProcessDto {
    return BorrowerProcessDtoToJSONTyped(json, false);
}

export function BorrowerProcessDtoToJSONTyped(value?: BorrowerProcessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medicalSurvey': BorrowerMedicalProcessDtoToJSON(value['medicalSurvey']),
        'medicalSurveyResponse': MedicalSurveyResponseProcessDtoToJSON(value['medicalSurveyResponse']),
        'approvedAgreement': BorrowerProcessStepDtoToJSON(value['approvedAgreement']),
        'subscriptionRequest': BorrowerProcessStepDtoToJSON(value['subscriptionRequest']),
        'subscriptionCertificate': BorrowerProcessStepDtoToJSON(value['subscriptionCertificate']),
        'medicalForm': BorrowerMedicalFormProcessDtoToJSON(value['medicalForm']),
        'partnerCaseStatus': value['partnerCaseStatus'],
        'partnerCaseStatusDetail': value['partnerCaseStatusDetail'],
    };
}

